'use strict';

require('./text.base.field.css');

export default class TextBaseFieldComponent {
  constructor() {
    this.restrict = 'E';
    this.template = require('./text.base.field.html');
    this.scope = {
      field: '=',
      isDerivedFromTemplate: '='
    };
    this.controller = TextBaseFieldController;
    this.controllerAs = 'ctrl';
    this.bindToController = true;
  }
}


/* @ngInject */
class TextBaseFieldController {
  constructor() {}
}
